(function($) {
    'use strict';

    $(document).ready(function() {
        // Category Slider
        $('.category-slider').each(function() {
            const $slider = $(this);
            const $section = $slider.closest('.category-slider-section');
            
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                dots: false,
                arrows: true,
                prevArrow: $section.find('.slick-prev-cat'),
                nextArrow: $section.find('.slick-next-cat'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });
    });

})(jQuery);
